.title {
    padding: 0;
    font-size: 24px;
    font-weight: 700;
    text-transform: uppercase;
}

.list {
    list-style: none;
    padding: 0;
}

.listItem {
    text-transform: uppercase;

    a {
        color: var(--color-lobster);
        text-transform: uppercase;
        text-decoration: none;

        &:hover {
            color: var(--color-black);
        }
    }
}
